import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import { API } from "../../Redux/actions/API";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Select from "react-select";
import axios from "axios";

function Edit_details() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const [searchParams, setSearchParams] = useSearchParams();
  const [uid, setuid] = useState(searchParams.get("userId"));
  const [f_name, setf_name] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [accountAddress, setaccountAddress] = useState("");
  const [counrtyid, setcounrtyid] = useState("");

  const [counrtyName, setcounrtyName] = useState("");
  const [IP, setIP] = useState("");

  const [stateID, setStateID] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtID, setDistrictID] = useState("");
  const [districtname, setDistrictname] = useState("");
  const [pincode, setPincode] = useState("");
  const [secretkey, setSecretkey] = useState("");
  const [password, setPassword] = useState("");
  const [trans_password, settrans_password] = useState("");

  const [Countries, setCountries] = useState([]);
  const [stateList, setstateList] = useState([]);
  const [districtList, setdistrictList] = useState([]);

  const [accountnumber, setaccountnumber] = useState("");
  const [holder, setholder] = useState("");
  const [ifsc, setifsc] = useState("");
  const [bank_name, setbank_name] = useState("");
  const [branch, setbranch] = useState("");
  const [PAN, setPAN] = useState("");
  const [AAdhar, setAAdhar] = useState("");

  useEffect(() => {
    const GetIp = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIP(response.data.ip);
      } catch {
        toast.error("Error in getting IP");
      }
    };
    GetIp();
  }, []);

  const CountryList_API = async () => {
    try {
      let res = await API.get(`countryList `);
      const fetchedCountries = res.data.data[0];
      setCountries(fetchedCountries);
    } catch (error) {
      console.log("Country API ERROR", error);
    }
  };

  const checkCountry = (e) => {
    const selectedCountryId = Number(e.target.value);
    const selectedCountry = Countries.find(
      (country) => country.id === selectedCountryId,
    );
    if (selectedCountry) {
      setcounrtyid(selectedCountry.id);
      setcounrtyName(selectedCountry.name);
      StateList_API(selectedCountry.id);
    }
  };

  const checkState = (e) => {
    const selectedStateId = Number(e.target.value);
    const selectedState = stateList.find(
      (State) => State.id === selectedStateId,
    );

    if (selectedState) {
      setStateID(selectedState.id);
      setStateName(selectedState.name);
      DistrictList_API(selectedState.id);
    }
  };

  const checkDistrict = (e) => {
    const selecteddistrictId = Number(e.target.value);
    const selecteddistrict = districtList.find(
      (district) => district.id === selecteddistrictId,
    );

    if (selecteddistrict) {
      setDistrictID(selecteddistrict.id);
      setDistrictname(selecteddistrict.name);
    }
  };

  const StateList_API = async (counrtyid) => {
    // console.log("CountryId", counrtyid);
    try {
      let response = await API?.post("getregion", {
        uid: userId,
        regiontype: "State",
        regionid: counrtyid,
      });
      // console.log("responsestate-->", counrtyid, response.data.data[0]);
      const fetchedStates = response.data.data[0];

      setstateList(fetchedStates);
    } catch (error) {
      console.log("state API ERROR", error);
    }
  };

  const DistrictList_API = async (stateID) => {
    try {
      let response = await API?.post("getregion", {
        uid: userId,
        regiontype: "district",
        regionid: stateID,
      });
      console.log("responsedis-->", response.data.data[0]);
      const fetcheddistrict = response.data.data[0];
      setdistrictList(fetcheddistrict);
    } catch (error) {
      console.log("District API ERROR", error);
    }
  };

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/GetUserProfile",
        {
          uid: uid,
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      console.log("referral_API", responceRight.data);
      responceRight = responceRight.data.data[0][0];

      setuid(responceRight.uid);
      setf_name(responceRight.f_name);
      setEmail(responceRight.email);
      setMobile(responceRight.mobile);

      setcounrtyid(responceRight.countryid);
      setcounrtyName(responceRight.countryname);
      setStateID(responceRight.stateid);
      setStateName(responceRight.statename);
      setDistrictID(responceRight.districtid);
      setDistrictname(responceRight.districtname);
      setPincode(responceRight.pincode);
      StateList_API(responceRight.countryid);
      DistrictList_API(responceRight.stateid);
      setaccountAddress(responceRight.accountaddress);
      setaccountnumber(responceRight.accountnumber);
      setholder(responceRight.holder);
      setifsc(responceRight.ifsc);
      setbank_name(responceRight.bank_name);
      setbranch(responceRight.branch);
      setPAN(responceRight.PAN);
      setAAdhar(responceRight.AAdhar);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const Update_Api = async () => {
    try {
      let responceRight = await API?.post(
        "/updateMemberProfile",
        {
          loginid: userId,
          uid: uid,
          f_name: f_name,
          email: email,
          mobile: mobile,
          accountnumber: accountnumber,
          counrtyid: counrtyid,
          countryName: counrtyName,
          stateID: stateID,
          statename: stateName,
          districtID: districtID,
          districtname: districtname,
          pincode: pincode,
          password: password,
          IP_address: IP,
          secretkey: secretkey,
          type: "profileupdate",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      // console.log("Update_Api", responceRight.data.data);
      if (responceRight.data.data === "Successfully update!") {
        toast.success(responceRight.data.data);
        setTimeout(() => {
          navigate("/Member_Details");
        }, 1000);
      } else {
        toast.error(responceRight.data.data);
      }
    } catch (e) {
      console.log("Update_Api", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const UpdatePassword_Api = async () => {
    try {
      let responceRight = await API?.post(
        "/updateMemberProfile",
        {
          loginid: userId,
          uid: uid,
          f_name: f_name,
          email: email,
          mobile: mobile,
          accountnumber: accountnumber,
          counrtyid: counrtyid,
          countryName: counrtyName,
          stateID: stateID,
          statename: stateName,
          districtID: districtID,
          districtname: districtname,
          pincode: pincode,
          password: password,
          trans_password: trans_password,
          IP_address: IP,
          type: "password",
          secretkey: secretkey,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      if (responceRight.data.data === "Successfully update!") {
        toast.success(responceRight.data.data);
        setTimeout(() => {
          navigate("/Member_Details");
        }, 1000);
      } else {
        toast.error(responceRight.data.data);
      }
    } catch (e) {
      console.log("Update_Api", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const Updatetrans_password_Api = async () => {
    try {
      let responceRight = await API?.post(
        "/updateMemberProfile",
        {
          loginid: userId,
          uid: uid,
          f_name: f_name,
          email: email,
          mobile: mobile,
          accountnumber: accountnumber,
          counrtyid: counrtyid,
          countryName: counrtyName,
          stateID: stateID,
          statename: stateName,
          districtID: districtID,
          districtname: districtname,
          pincode: pincode,
          password: password,
          trans_password: trans_password,
          IP_address: IP,
          type: "trans_password",
          secretkey: secretkey,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      if (responceRight.data.data === "Successfully update!") {
        toast.success(responceRight.data.data);
        setTimeout(() => {
          navigate("/Member_Details");
        }, 1000);
      } else {
        toast.error(responceRight.data.data);
      }
    } catch (e) {
      console.log("Update_Api", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const UpdateBnbAddress_Api = async () => {
    try {
      let responceRight = await API?.post(
        "/updateMemberProfile",
        {
          loginid: userId,
          uid: uid,
          f_name: f_name,
          email: email,
          mobile: mobile,
          accountnumber: accountAddress,
          counrtyid: counrtyid,
          countryName: counrtyName,
          stateID: stateID,
          statename: stateName,
          districtID: districtID,
          districtname: districtname,
          pincode: pincode,
          password: password,
          trans_password: trans_password,
          IP_address: IP,
          secretkey: secretkey,
          type: "ecurrency",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      if (responceRight.data.data === "Successfully update!") {
        toast.success(responceRight.data.data);
        setTimeout(() => {
          navigate("/Member_Details");
        }, 1000);
      } else {
        toast.error(responceRight.data.data);
      }
    } catch (e) {
      console.log("Update_Api", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
    CountryList_API();
  }, []);

  const [validName, setvalidName] = useState(true);
  const handleName = (e) => {
    const result = e.target.value.replace(/[^a-z ]/gi, "");
    setf_name(result);

    e.target.value ? setvalidName(true) : setvalidName(false);
  };

  const [validmobile, setValidMobile] = useState(true);
  const handleMobile = (e) => {
    const result = e.target.value.replace(/[^0-9]/gi, "");
    setMobile(result);

    e.target.value.indexOf("0") === 0
      ? setValidMobile(false)
      : e.target.value.length <= 9
        ? setValidMobile(false)
        : setValidMobile(true);
  };

  const [valid, setValid] = useState(true);
  const EmailValidation = (event) => {
    const inputValue = event.target.value;
    setEmail(inputValue);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(inputValue);
    setValid(isValid);
  };

  const UpdateBankDetails_Api = async () => {
    try {
      if (
        accountnumber === "" ||
        holder === "" ||
        ifsc === "" ||
        bank_name === "" ||
        branch === "" ||
        PAN === "" ||
        AAdhar === ""
      ) {
        return toast.error("Enter All bank details");
      }

      const responceRight = await API.post(
        "/updateMemberProfile",
        {
          loginid: userId,
          uid: uid,

          accountnumber: accountnumber,
          holder: holder,
          ifsc: ifsc,
          bank_name: bank_name,
          branch: branch,
          PAN: PAN,
          AAdhar: AAdhar,
          IP_address: IP,
          type: "bankdetails",
          secretkey: secretkey,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      if (responceRight.data.data === "Successfully update!") {
        toast.success(responceRight.data.data);
        setTimeout(() => {
          navigate("/Member_Details");
        }, 1000);
      } else {
        toast.error(responceRight.data.data);
      }
    } catch (e) {
      console.log("Update_Api", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const GetBankByIFSC_API = async (IFSCode) => {
    try {
      let res = await axios.get(`https://ifsc.razorpay.com/${IFSCode}`);

      setbank_name(res.data?.BANK);
      setbranch(res.data?.BRANCH);
    } catch (error) {
      console.log("Country API ERROR", error);
    }
  };
  useEffect(() => {
    GetBankByIFSC_API(ifsc);
  }, [ifsc]);
  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Edit Member Details</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-6">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-12" style={{ marginLeft: "40px" }}>
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <div className="form-group">
                                  <label>User Id</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Name"
                                    value={uid}
                                    readOnly
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Name</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Name"
                                    value={f_name}
                                    onChange={(e) => handleName(e)}
                                  />
                                  {!validName && (
                                    <p className="" style={{ color: "red" }}>
                                      Please Enter Valid Name.
                                    </p>
                                  )}
                                </div>
                                <div className="form-group">
                                  <label>Email Id</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Email"
                                    value={email}
                                    onChange={(e) => EmailValidation(e)}
                                  />
                                  {!valid && (
                                    <p className="" style={{ color: "red" }}>
                                      Please Enter Valid Email.
                                    </p>
                                  )}
                                </div>
                                <div className="form-group">
                                  <label>Mobile No</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Mobile Number"
                                    value={mobile}
                                    onChange={(e) => handleMobile(e)}
                                  />
                                  {!validmobile && (
                                    <p className="" style={{ color: "red" }}>
                                      Please Enter Valid Mobile No.
                                    </p>
                                  )}
                                </div>

                                {/* <div className="form-group">
                                  <label>Country Name</label>
                                  <select
                                    name="country"
                                    className="form-control"
                                    value={counrtyid}
                                    onChange={checkCountry}
                                  >
                                    <option value="" disabled>
                                      Select Country
                                    </option>
                                    {Countries.map((country) => (
                                      <option
                                        key={country.id}
                                        value={country.id.toString()}
                                      >
                                        {country.name}
                                      </option>
                                    ))}
                                  </select>
                                </div> */}

                                {/* <div className="form-group">
                                  <label>State Name</label>
                                  <select
                                    name="state"
                                    className="form-control"
                                    value={stateID}
                                    onChange={checkState}
                                  >
                                    <option value="" disabled>
                                      Select State
                                    </option>
                                    {stateList.map((state) => (
                                      <option
                                        key={state.id}
                                        value={state.id.toString()}
                                      >
                                        {state.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="form-group">
                                  <label>District Name</label>
                                  <select
                                    name="state"
                                    className="form-control"
                                    value={districtID}
                                    onChange={checkDistrict}
                                  >
                                    <option value="" disabled>
                                      Select State
                                    </option>
                                    {districtList.map((district) => (
                                      <option
                                        key={district.id}
                                        value={district.id.toString()}
                                      >
                                        {district.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                <div className="form-group">
                                  <label>Pin Code</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Pin Code"
                                    maxLength={6}
                                    value={pincode}
                                    onChange={(e) => setPincode(e.target.value)}
                                  />
                                </div> */}

                                <div className="form-group">
                                  <label>Secret Key </label>
                                  <input
                                    type="password"
                                    id="secretkey"
                                    class="form-control"
                                    placeholder="Enter Secret Key"
                                    maxLength={6}
                                    value={secretkey}
                                    onChange={(e) =>
                                      setSecretkey(e.target.value)
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <div class="joinbtn d-flex flex-row-reverse me-auto">
                                    <button
                                      id="btnactive"
                                      style={{
                                        color: "white",
                                        border: "solid 1px #ffff",
                                        padding: "10px 20px",
                                        marginTop: "20px",
                                        background: "blue",
                                      }}
                                      onClick={() => Update_Api()}
                                      disabled={
                                        valid && validName ? false : true
                                      }
                                    >
                                      Update Profile
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box col-md-6">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-12" style={{ marginLeft: "40px" }}>
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <h2>Update Bank Details </h2>
                                <div className="form-group">
                                  <label> User ID</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Wallet Address"
                                    value={`${uid}`}
                                    readOnly
                                  />
                                </div>

                                <div className="form-group">
                                  <label>Account Number</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={accountnumber}
                                    onChange={(e) =>
                                      setaccountnumber(e.target.value)
                                    }
                                    maxLength={20}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Account Holder Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={holder}
                                    onChange={(e) => setholder(e.target.value)}
                                    maxLength={100}
                                  />
                                </div>

                                <div className="form-group">
                                  <label>IFSC Code</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={ifsc}
                                    onChange={(e) => {
                                      setifsc(e.target.value.toUpperCase());
                                    }}
                                    maxLength={11}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Bank Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={bank_name}
                                    readOnly
                                    // onChange={(e) =>
                                    //   setbank_name(e.target.value)
                                    // }
                                    maxLength={50}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Branch Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={branch}
                                    readOnly
                                    // onChange={(e) => setbranch(e.target.value)}
                                    // maxLength={50}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>PAN Number</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={PAN}
                                    onChange={(e) =>
                                      setPAN(e.target.value.toUpperCase())
                                    }
                                    maxLength={12}
                                  />
                                </div>
                                {/* <div className="form-group">
                                  <label>Aadhar Number</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={AAdhar}
                                    onChange={(e) =>
                                      setAAdhar(e.target.value.toUpperCase())
                                    }
                                    maxLength={12}
                                  />
                                </div> */}
                                <div className="form-group">
                                  <label>Secret Key</label>
                                  <input
                                    type="password"
                                    class="form-control"
                                    placeholder="Secret key"
                                    value={secretkey}
                                    onChange={(e) =>
                                      setSecretkey(e.target.value)
                                    }
                                    maxLength={6}
                                  />
                                </div>
                                <div className="form-group">
                                  <div class="joinbtn d-flex flex-row-reverse me-auto">
                                    <button
                                      id="btnactivepswd"
                                      style={{
                                        color: "white",
                                        border: "solid 1px #ffff",
                                        padding: "10px 20px",
                                        marginTop: "20px",
                                        background: "blue",
                                      }}
                                      onClick={() => UpdateBankDetails_Api()}
                                    >
                                      Update Bank Details
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box col-md-6">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-12" style={{ marginLeft: "40px" }}>
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="form-group">
                                  <label>Password</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Password"
                                    value={password}
                                    onChange={(e) =>
                                      setPassword(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Secret Key</label>
                                  <input
                                    type="password"
                                    class="form-control"
                                    placeholder="Secret key"
                                    value={secretkey}
                                    onChange={(e) =>
                                      setSecretkey(e.target.value)
                                    }
                                    maxLength={6}
                                  />
                                </div>
                                {/* <div className="form-group">
                                  <label>Transaction Password</label>
                                  <input
                                    type="text"
                                    id="transpassword"
                                    class="form-control"
                                    placeholder="Enter Transaction Password"
                                    value={transpassword}
                                    onChange={(e) =>
                                      settranspassword(e.target.value)
                                    }
                                  />
                                </div> */}

                                <div className="form-group">
                                  <div class="joinbtn d-flex flex-row-reverse me-auto">
                                    <button
                                      id="btnactivepswd"
                                      style={{
                                        color: "white",
                                        border: "solid 1px #ffff",
                                        padding: "10px 20px",
                                        marginTop: "20px",
                                        background: "blue",
                                      }}
                                      onClick={() => UpdatePassword_Api()}
                                    >
                                      Update Password
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-12" style={{ marginLeft: "40px" }}>
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="form-group">
                                  <label>Transction Password</label>
                                  <input
                                    type="text"
                                    id="txttranspass"
                                    class="form-control"
                                    placeholder="Enter Transction Password"
                                    value={trans_password}
                                    onChange={(e) =>
                                      settrans_password(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Secret Key</label>
                                  <input
                                    type="password"
                                    class="form-control"
                                    placeholder="Secret key"
                                    value={secretkey}
                                    onChange={(e) =>
                                      setSecretkey(e.target.value)
                                    }
                                    maxLength={6}
                                  />
                                </div>
                                {/* <div className="form-group">
                                  <label>Transaction Password</label>
                                  <input
                                    type="text"
                                    id="transpassword"
                                    class="form-control"
                                    placeholder="Enter Transaction Password"
                                    value={transpassword}
                                    onChange={(e) =>
                                      settranspassword(e.target.value)
                                    }
                                  />
                                </div> */}

                                <div className="form-group">
                                  <div class="joinbtn d-flex flex-row-reverse me-auto">
                                    <button
                                      id="btnactivepswdtrans"
                                      style={{
                                        color: "white",
                                        border: "solid 1px #ffff",
                                        padding: "10px 20px",
                                        marginTop: "20px",
                                        background: "blue",
                                      }}
                                      onClick={() => Updatetrans_password_Api()}
                                    >
                                      Update Tansction Password
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-12" style={{ marginLeft: "40px" }}>
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="form-group">
                                  <label>USDT BEP 20 Address</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Wallet Address"
                                    value={accountAddress}
                                    onChange={(e) =>
                                      setaccountAddress(e.target.value)
                                    }
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Secret Key </label>
                                  <input
                                    type="password"
                                    id="secretkey"
                                    class="form-control"
                                    placeholder="Enter Secret Key"
                                    maxLength={6}
                                    value={secretkey}
                                    onChange={(e) =>
                                      setSecretkey(e.target.value)
                                    }
                                  />
                                </div>

                                <div className="form-group">
                                  <div class="joinbtn d-flex flex-row-reverse me-auto">
                                    <button
                                      id="btnactivepswd"
                                      style={{
                                        color: "white",
                                        border: "solid 1px #ffff",
                                        padding: "10px 20px",
                                        marginTop: "20px",
                                        background: "blue",
                                      }}
                                      onClick={() => UpdateBnbAddress_Api()}
                                    >
                                      Update USDT BEP 20 Address
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Edit_details;
